/**
 * @generated SignedSource<<64827a0ccf4bdea8c8681465aa8b7336>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WaitlistRendererQueueSlotSubscription$variables = {
  agendaId: string;
};
export type WaitlistRendererQueueSlotSubscription$data = {
  readonly queueSlotChanged: {
    readonly slots: ReadonlyArray<{
      readonly bookings?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly request?: {
              readonly time: string;
            } | null | undefined;
            readonly " $fragmentSpreads": FragmentRefs<"WaitlistBooking_Booking">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly id?: string;
      readonly queueCount?: {
        readonly count: number;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type WaitlistRendererQueueSlotSubscription = {
  response: WaitlistRendererQueueSlotSubscription$data;
  variables: WaitlistRendererQueueSlotSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agendaId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "agendaIds.0",
        "variableName": "agendaId"
      }
    ],
    "kind": "ListValue",
    "name": "agendaIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": "queueCount",
  "args": null,
  "concreteType": "BookingConnection",
  "kind": "LinkedField",
  "name": "bookings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": {
    "direction": "ASC",
    "field": "REQUESTED_DATE_TIME"
  }
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  },
  (v4/*: any*/)
],
v10 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WaitlistRendererQueueSlotSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SlotsSubscriptionChange",
        "kind": "LinkedField",
        "name": "queueSlotChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "slots",
            "plural": true,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": "bookings",
                    "args": [
                      (v4/*: any*/)
                    ],
                    "concreteType": "BookingConnection",
                    "kind": "LinkedField",
                    "name": "__queueSlot_bookings_connection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BookingEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Request",
                                    "kind": "LinkedField",
                                    "name": "request",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "StandardBooking",
                                "abstractKey": null
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "WaitlistBooking_Booking"
                              },
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": "__queueSlot_bookings_connection(orderBy:{\"direction\":\"ASC\",\"field\":\"REQUESTED_DATE_TIME\"})"
                  }
                ],
                "type": "QueueSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WaitlistRendererQueueSlotSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SlotsSubscriptionChange",
        "kind": "LinkedField",
        "name": "queueSlotChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "slots",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "concreteType": "BookingConnection",
                    "kind": "LinkedField",
                    "name": "bookings",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BookingEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v2/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isBooking"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "canUpdate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "writeAccess",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "startSlot",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Agenda",
                                        "kind": "LinkedField",
                                        "name": "agenda",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "date",
                                            "storageKey": null
                                          },
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "QueueSlot",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v10/*: any*/),
                                "concreteType": "RoundConnection",
                                "kind": "LinkedField",
                                "name": "rounds",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoundEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*: any*/),
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TransportationType",
                                            "kind": "LinkedField",
                                            "name": "transportationType",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "code",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CourseLayout",
                                            "kind": "LinkedField",
                                            "name": "courseLayout",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "holeCount",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "player",
                                            "plural": false,
                                            "selections": [
                                              (v6/*: any*/),
                                              (v2/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "firstName",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "lastName",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": "rounds(first:100)"
                              },
                              {
                                "alias": null,
                                "args": (v10/*: any*/),
                                "filters": null,
                                "handle": "connection",
                                "key": "booking_rounds",
                                "kind": "LinkedHandle",
                                "name": "rounds"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Request",
                                    "kind": "LinkedField",
                                    "name": "request",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "StandardBooking",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": "bookings(first:1000,orderBy:{\"direction\":\"ASC\",\"field\":\"REQUESTED_DATE_TIME\"})"
                  },
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "filters": [
                      "orderBy"
                    ],
                    "handle": "connection",
                    "key": "queueSlot_bookings",
                    "kind": "LinkedHandle",
                    "name": "bookings"
                  }
                ],
                "type": "QueueSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3f760d49e28a1e47ef6d97c755bd8530",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": null
        }
      ]
    },
    "name": "WaitlistRendererQueueSlotSubscription",
    "operationKind": "subscription",
    "text": "subscription WaitlistRendererQueueSlotSubscription(\n  $agendaId: ID!\n) {\n  queueSlotChanged(agendaIds: [$agendaId]) {\n    slots {\n      __typename\n      ... on QueueSlot {\n        id\n        queueCount: bookings {\n          count\n        }\n        bookings(first: 1000, orderBy: {field: REQUESTED_DATE_TIME, direction: ASC}) {\n          edges {\n            node {\n              __typename\n              id\n              ... on StandardBooking {\n                request {\n                  time\n                  id\n                }\n              }\n              ...WaitlistBooking_Booking\n            }\n            cursor\n          }\n          pageInfo {\n            endCursor\n            hasNextPage\n          }\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment WaitlistBooking_Booking on Booking {\n  __isBooking: __typename\n  id\n  canUpdate\n  writeAccess\n  ... on StandardBooking {\n    request {\n      time\n      id\n    }\n  }\n  startSlot {\n    __typename\n    id\n    ... on QueueSlot {\n      id\n      agenda {\n        date\n        id\n      }\n    }\n  }\n  rounds(first: 100) {\n    edges {\n      node {\n        id\n        __typename\n        transportationType {\n          id\n          code\n        }\n        courseLayout {\n          id\n          holeCount\n        }\n        player {\n          __typename\n          id\n          firstName\n          lastName\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bcb307429646938f14119186eb3896e8";

export default node;
